import Cookies from "js-cookie"

export default () => {
  if (Cookies.get("lng") == "zh") {
    Cookies.set("lng", "ch", { domain: ".englishlive.ef.com" })
  }
}
